enum ShortGenericNameConstants {
  Battery = 'BATTERY',
  RoboticLawnMower = 'ROBOTIC LAWN MOWER',
  Gateway = 'GATEWAY',
  ConnectivityModule = 'CONNECTIVITY MODULE',
}

export default ShortGenericNameConstants;
